// removed by extract-text-webpack-plugin
module.exports = {"Support":"_3liI1gs1_EiAzLAluvwmfv","SupportNoMax":"_17otlcHQYh0SaBrPkPy2TH"};


//////////////////
// WEBPACK FOOTER
// ./src/components/support/support.css
// module id = 206
// module chunks = 0